import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import {FaTh} from 'react-icons/fa'
import {FaSliders} from 'react-icons/fa6'
import {AiFillCloseCircle} from 'react-icons/ai'
import Drop from './Drop'
import {FaAngleDown} from 'react-icons/fa'
import { userContext } from '../App'
import { useContext } from 'react'

const Navbar2 = () => {
  const nav=useNavigate()
  const [open,setopen]=useState(true)
  const handle=()=>{
    setopen((prev)=>!prev)
}
console.log(open);


const [search,hand,setsearch,location,setlocation,Locate,Kotei,Ayeduasi,Newsite,TechJunction,KNUSTCampus,Bomsu,Kumasi,price,setprice,main,price1,price2,price3,price4,price5,price6,price7,type,settype,types,Apartments,GuestHouse,homstel,Hostels,collapse,toggle,settoggle,toggler,arrow,setarrow, down,click,setclick,onpress]=useContext(userContext)


  function filter(){
     <div className=' bg-gray-500 w-96 h-56 top-52 my-80'style={{zIndex:'10',position:'relative', width:'30%',height:'40%'}}>
      <label>Search</label>
      <input type='text' />
    </div>
  }
  return (
    <div className='  bg-gray-100 h-12 flex justify-end fixed z-50 w-full top-0'>
      <div className='mx-auto px-2 sm:px-6 lg:px-6'>
        <div className='flex items-center lg:text-xl gpy-4 text-center from-neutral-800 py-2'>
          <div className='space-x-5 justify-center lg:mx-96 '>
  <Link to='/home'>Home</Link>
  <Link to='/'>Explore</Link>
<button className=' bg-blue-600 w-24 shadow-lg rounded-md h-8' onClick={handle}>
  <div className=' inline-block font-light text-xl text-white h-7' style={{fontSize:"20px"}}>Filter</div>
  <div className=' inline-block mx-1 w-3'><FaSliders style={{color:'white',fontSize:'20px',paddingTop:'5px'}} /></div>
  </button>
   {open==false?<div className=' mt-28 md:w-[500px] h-96 bg-gray-50 rounded-2xl shadow-2xl mx-10 w-[370px]'>
<div className='my-5 py-5 cursor-pointer md:px-[110px] px-0' style={{marginLeft:'320px'}} ><AiFillCloseCircle style={{width:'50px',height:'30px'}}  onClick={handle}  /></div>
<div className=' grid grid-cols-2 ml-8 gap-4 '>
  <div className='relative'>
<div className=' border-solid flex justify-between border-gray-300 border-[1px] px-4 md:w-[230px] py-1 rounded-md cursor-default md:ml-0 w-[150px] md:h-10 -ml-5 '  onClick={toggler}>{location}<FaAngleDown style={{marginTop:'8px'}} /></div>
{toggle==false?
<div className='rounded border-gray-400 bg-white p-0 md:w-[230px] w-[150px] h-64 border-1 shadow-xl absolute md:-ml-[0px] text-gray-900 font-thin text-lg -ml-5 ' onClick={collapse}>
<div className=' md:w-[230px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={Locate}>location </div>
<div className=' md:w-[230px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={Ayeduasi}>Ayeduasi </div>
<div className=' md:w-[230px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={Kotei}>Kotei </div>
<div className='  md:w-[230px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={Newsite}>Newsite </div>
<div className='   md:w-[230px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={Kumasi}>Kumasi </div>
<div className='   md:w-[230px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={KNUSTCampus}>KNUSTCampus</div>
<div className='   md:w-[230px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={Bomsu}>Bomsu</div>
<div className='   md:w-[230px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={TechJunction}>TechJunction</div>
</div>
:
<div>{null}</div>
}
</div>

<div className='relative'>
<div className=' border-solid flex justify-between border-gray-300 border-[1px] px-4 md:w-52 h-[35px] py-1 rounded-md  cursor-default md:text-[16px] text-[13px] md:h-10 w-[190px] md:-ml-0 -ml-10 '  onClick={onpress}>Ghc {price}<FaAngleDown style={{marginTop:'8px'}} /></div>
{click==false?
<div className='rounded border-gray-400 bg-white p-0 md:w-52 h-64 border-1 shadow-xl absolute md:-mx-0 text-gray-900 font-thin text-lg w-[190px] -mx-9 ' onClick={collapse}>
<div className=' md:w-52 h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={main}>Price </div>
<div className=' md:w-52 h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={price7}>Ghc2300 - Ghc 4500 </div>
<div className='  md:w-52 h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={price1}>Ghc2300 - Ghc 5500 </div>
<div className='  md:w-52 h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={price2}>Ghc2800 - Ghc 6000 </div>
<div className='md:w-52 h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={price3}>Ghc6000 - Ghc 17000 </div>
<div className=' md:w-52 h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={price4}>Ghc 3000 - Ghc 5000</div>
<div className='   md:w-52 h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={price5}>Ghc 8000 - Ghc 17000</div>
<div className='  md:w-52 h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={price6}>Ghc 2400 - Ghc 4800</div>
</div>
:
<div>{null}</div>
}
</div>
</div>
<div className=' grid grid-cols-1 my-6 mx-8'>
<div type='text ' className=' border-solid flex justify-between border-gray-300 border-[1px] px-4 md:w-[450px] py-1 rounded-md cursor-default -mx-[18px] w-[346px] md:mx-0'  onClick={down}>{type}<FaAngleDown style={{marginTop:'8px'}} /></div>
{arrow==false?
<div className='rounded border-gray-400 bg-white  md:w-[450px] h-42 border-1 shadow-xl absolute md:mx-0 -mx-4 mt-9 px-0 py-6 text-gray-900 font-thin text-lg w-[346px] ' onClick={collapse}>
<div className='  md:w-[450px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={types}>type </div>
<div className=' md:w-[450px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={Apartments}>Apartment </div>
<div className='  md:w-[450px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={GuestHouse}>GuestHouse</div>
<div className='   md:w-[450px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={Hostels}>Hostel </div>
<div className='   md:w-[450px] h-8 hover:rounded-md hover:shadow-md hover:bg-blue-600 cursor-default' onClick={homstel}>Homestel </div>

</div>
:
<div>{null}</div>
}
</div>

<div className=' font-normal text-lg mt-2 inline-block md:-ml-[80px]'><input className='  border-solid border-2 bg-blue-500 w-5 h-4 rounded-md shadow-md ' type="checkbox" name="Pool " id="Pool"/> WIFI</div>
<div className=' font-normal text-lg md:-ml-56 mt-2  inline-block mx-24'><input className=' border-solid border-2 bg-blue-500 w-5 h-4 rounded-md shadow-md ' type="checkbox" name="DS TV" id="DS TV"/> DS TV</div>

<div className=' grid grid-cols-1 mx-5'>
<button className=' bg-blue-600 w-20 h-8 mt-6 mx-5  rounded-lg shadow-2xl text-white' onClick={handle}>Filter</button>
</div>
   </div>:<div>
    {null}
    </div>}
  </div>
    </div>
      </div>
    </div>


  ) 
}

export default Navbar2
   